import * as React from 'react';

import { Box, Typography } from '@mui/material';

import { ShippingRegion } from '../../../graphql/API';
import Icons from '../../../themes/icons';
import BaseDialog, { BaseDialogProps } from '../Base';
import ProductRequestsFilter, { ProductRequestsFiltersProps } from './ProductRequestsFilters';
import { PartialVenueListAccessRequestsFilter } from './types';

type CollabsFiltersDialogProps = {
  filters?: PartialVenueListAccessRequestsFilter;
  onFilterChange: ProductRequestsFiltersProps['onChange'];
  allShippingRegions?: ShippingRegion[];
} & BaseDialogProps;

export const ProductRequestsFiltersDialog: React.FC<CollabsFiltersDialogProps> = ({
  filters,
  onFilterChange,
  allShippingRegions = [],
  ...restProps
}) => {
  return (
    <BaseDialog
      height='634px'
      titleComponent={
        <Box display={'flex'} alignItems={'center'} gap={'8px'}>
          <Icons.FiltersIcon style={{ width: '34px', height: '34px' }} />
          <Typography fontSize={'20px'} fontWeight={'500'}>
            Filters
          </Typography>
        </Box>
      }
      {...restProps}
    >
      <ProductRequestsFilter
        onChange={onFilterChange}
        filters={filters}
        onClose={() => {
          if (restProps.onClose) restProps?.onClose({}, 'escapeKeyDown');
        }}
        allShippingRegions={allShippingRegions}
      />
    </BaseDialog>
  );
};
